import { useAppSelector } from "@app/hooks";
import { carlyleReportingFundsAvailableSelector } from "@app/store/selectors";

/**
 * LPC-11108: true only when the user has an entitled fund that actually carries Carlyle
 * reporting data. Internal FAP funds grant Carlyle report permissions but return no
 * reporting data, so they must not enable the Carlyle reporting menu/routes.
 */
export const useFundsDataValidation = (): boolean => useAppSelector(carlyleReportingFundsAvailableSelector);
